module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/images/background-onslaught.383e5c18.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/images/background-onslaught.jpg
// module id = 2818
// module chunks = 11